const storyboardFilterTypes = Object.freeze({
  OPTIONAL_SINGLESELECT: "optionalSingleSelect",
  MANDATORY_SINGLESELECT: "mandatorySingleSelect",
  MULTISELECT: "multiSelect",
  CONDITIONAL: "conditional",
});

export default storyboardFilterTypes;
